var React = require('react');

function IcArrowForwardInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16,10.431l-.757-.82-6.7,7.267V0H7.459V16.878L.757,9.611,0,10.431,8,19.1Z","transform":"translate(0 16) rotate(-90)","fill":"#fff"}));
}

IcArrowForwardInline.defaultProps = {"width":"19.105","height":"16","viewBox":"0 0 19.105 16"};

module.exports = IcArrowForwardInline;

IcArrowForwardInline.default = IcArrowForwardInline;
